import React from 'react';
import styled from 'styled-components/macro';
import { Box } from '../SubComponents/Modals';
import { BigLabel, Label, SubLabel } from '../SubComponents/Text';
import { IconButton } from '../SubComponents/Buttons';
import { ReactComponent as Minus } from '../Assets/Icons/minus.svg';
import { ReactComponent as Plus } from '../Assets/Icons/plus.svg';
import { useGetCustomBookingLocalization } from '../Hooks/use-get-custom-booking-localization';
import useTypeSafeLocalize from '../Hooks/use-type-safe-localize';
import { BookingLocalization } from '../Utils/graphql-sdk';
import { LocalizationCategory, ProductLocalization } from '../localizations/types';

const BoatCountWrapper = styled.div`
  display: flex;
  margin-bottom: 32px;
  @media screen and (max-width: 767px) {
    justify-content: space-between;
  }
`;

const BoatCountLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 767px) {
    padding: 0 12px;
  }
`;

export interface BoatCountProps {
  boatCount: number;
  onAdd: () => void;
  onSubtract: () => void;
  enabled?: boolean;
  personsPerUnit?: number;
  error: any;
}

const BoatCount = (props: BoatCountProps) => {
  const {
    boatCount,
    onAdd,
    onSubtract,
    error,
    enabled = true,
    personsPerUnit = 8,
  } = props;
  const localize = useTypeSafeLocalize();
  const getCustomBookingLocalization = useGetCustomBookingLocalization();
  const numberOfUnits =
    getCustomBookingLocalization(BookingLocalization.NumberOfUnits) ||
    localize(LocalizationCategory.product, ProductLocalization.numberOfUnits);
  const personsPerUnitString =
    getCustomBookingLocalization(BookingLocalization.PersonsPerUnit) ||
    localize(LocalizationCategory.product, ProductLocalization.personsPerUnit).replace(
      '8',
      String(personsPerUnit)
    );

  return (
    <BoatCountWrapper>
      <BoatCountLabelWrapper>
        <Label>{numberOfUnits}</Label>
        <SubLabel>{personsPerUnitString}</SubLabel>
      </BoatCountLabelWrapper>
      <Box justifyContent="space-between" ml="3" width="auto" error={error}>
        <IconButton
          onClick={onSubtract}
          icon={Minus}
          altText="Subtract boat"
          width="35px"
          height="35px"
          p="10px"
          disabled={!enabled}
        />
        <BigLabel mx="20px" lineHeight="35px">
          {boatCount}
        </BigLabel>
        <IconButton
          onClick={onAdd}
          icon={Plus}
          altText="Add boat"
          width="35px"
          height="35px"
          p="10px"
          disabled={!enabled}
        />
      </Box>
    </BoatCountWrapper>
  );
};

export default BoatCount;
